(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_kv-collection-tabs"] && !Shopify.designMode) return;
  try {
    class KvCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.activeIndex = Math.max(
        0,
        Array.from(this.querySelectorAll('.kv-collection-tabs__tab')).findIndex(
          (tab) => tab.getAttribute('aria-selected') === 'true'
        )
      );
      this.cache = new Map();
      this.pending = new Map();

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);

      this.onLayoutChange = (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.name !== 'grid' && input.name !== 'grid-mobile') return;
        this.setGridView(input.value);
      };
      document.addEventListener('change', this.onLayoutChange);
      this.applyStoredLayout();

      this.onFilterUpdate = () => requestAnimationFrame(() => this.refresh());
      document.addEventListener('filter:update', this.onFilterUpdate);
      window.addEventListener('popstate', this.onFilterUpdate);

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden', 'aria-selected'],
      });

      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onLayoutChange);
      document.removeEventListener('filter:update', this.onFilterUpdate);
      window.removeEventListener('popstate', this.onFilterUpdate);
      this.observer?.disconnect();
    }

    applyStoredLayout() {
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const checked = document.querySelector(
        desktop ? 'input[name="grid"]:checked' : 'input[name="grid-mobile"]:checked'
      );
      const stored = sessionStorage.getItem(
        desktop ? 'product-grid-view-desktop' : 'product-grid-view-mobile'
      );
      const value = (checked && checked.value) || stored;
      if (value) this.setGridView(value);
    }

    setGridView(value) {
      this.gridView = value;
      this.querySelectorAll('.kv-collection-tabs__grid').forEach((grid) => {
        grid.setAttribute('product-grid-view', value);
      });
    }

    get tabs() {
      return Array.from(this.querySelectorAll('.kv-collection-tabs__tab'));
    }

    get panels() {
      return Array.from(this.querySelectorAll('.kv-collection-tabs__panel'));
    }

    onClick = (event) => {
      const tab = event.target.closest('.kv-collection-tabs__tab');
      if (!tab) return;
      this.selectTab(this.tabs.indexOf(tab));
    };

    onKeydown = (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const tabs = this.tabs;
      const index = tabs.indexOf(event.target.closest('.kv-collection-tabs__tab'));
      if (index === -1) return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const next = (index + direction + tabs.length) % tabs.length;
      this.selectTab(next);
      tabs[next].focus();
    };

    selectTab(index) {
      if (index < 0) return;
      this.activeIndex = index;
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        if (tab.getAttribute('aria-selected') !== String(selected)) {
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        }
        tab.classList.toggle('kv-collection-tabs__tab--active', selected);
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel, panelIndex) => {
        const hidden = panelIndex !== index;
        if (panel.hidden !== hidden) panel.hidden = hidden;
      });

      const heading = this.querySelector('.kv-collection-tabs__heading');
      const activeTab = this.tabs[index];
      if (heading && activeTab) {
        heading.textContent = activeTab.textContent.trim();
      }
    }

    filterQuery() {
      const params = new URLSearchParams(window.location.search);
      const query = new URLSearchParams();
      for (const [key, value] of params.entries()) {
        if (key.startsWith('filter.') || key === 'sort_by') query.append(key, value);
      }
      return query.toString();
    }

    sync() {
      const tabs = this.tabs;
      const activeTab = tabs[this.activeIndex];
      if (activeTab && activeTab.getAttribute('aria-selected') !== 'true') {
        this.selectTab(this.activeIndex);
      }

      const query = this.filterQuery();
      if (!query) return;
      this.panels.forEach((panel) => {
        const grid = panel.querySelector('.kv-collection-tabs__grid');
        const key = `${panel.dataset.kvTabIndex}|${query}`;
        if (grid && grid.dataset.kvFilter !== query && this.cache.has(key)) {
          this.applyGrid(panel, this.cache.get(key), query);
        }
      });
    }

    refresh() {
      const query = this.filterQuery();
      if (!query) return;
      this.panels.forEach((panel) => this.loadPanel(panel, query));
    }

    async loadPanel(panel, query) {
      const index = panel.dataset.kvTabIndex;
      const key = `${index}|${query}`;

      if (this.cache.has(key)) {
        this.applyGrid(panel, this.cache.get(key), query);
        return;
      }
      if (this.pending.has(key)) return;

      const url = new URL(panel.dataset.kvCollectionUrl, window.location.origin);
      url.search = query;
      url.searchParams.set('section_id', this.dataset.sectionId);

      const request = fetch(url.toString())
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          if (!html) return null;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const remotePanel = doc.querySelector(
            `.kv-collection-tabs__panel[data-kv-tab-index="${index}"] .kv-collection-tabs__grid`
          );
          return remotePanel ? remotePanel.innerHTML : null;
        })
        .catch(() => null);

      this.pending.set(key, request);
      const gridHTML = await request;
      this.pending.delete(key);

      if (gridHTML === null) return;
      this.cache.set(key, gridHTML);
      if (this.filterQuery() !== query) return;

      const livePanel = this.panels.find((item) => item.dataset.kvTabIndex === index);
      if (livePanel) this.applyGrid(livePanel, gridHTML, query);
    }

    applyGrid(panel, gridHTML, query) {
      const grid = panel.querySelector('.kv-collection-tabs__grid');
      if (!grid || grid.dataset.kvFilter === query) return;

      const html = (gridHTML || '').trim();
      const hasProducts = html.includes('product-grid__item');
      const empty = panel.querySelector('.main-collection-grid__empty');

      if (hasProducts) {
        grid.innerHTML = gridHTML;
        grid.hidden = false;
        if (this.gridView) grid.setAttribute('product-grid-view', this.gridView);
        if (empty) empty.hidden = true;
      } else {
        grid.innerHTML = '';
        grid.hidden = true;
        if (empty) empty.hidden = false;
      }

      grid.dataset.kvFilter = query;
    }
  }

  if (!customElements.get('kv-collection-tabs')) {
    customElements.define('kv-collection-tabs', KvCollectionTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-reveal-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-reveal-timeline')) {
    class ScrollRevealTimeline extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        this.track = this.querySelector('[data-timeline-track]');
        this.icons = Array.from(this.querySelectorAll('.scroll-timeline__icon'));
        this.frame = null;
        this.update = this.update.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(this.update);
      }

      update() {
        this.frame = null;
        const viewportHeight = window.innerHeight;
        const clearLine = viewportHeight * 0.68;
        const fadeLine = viewportHeight * 0.94;
        const range = fadeLine - clearLine;

        this.items.forEach((item) => {
          const center = item.getBoundingClientRect().top + Math.min(item.offsetHeight * 0.25, 48);
          const progress = Math.max(0, Math.min(1, (fadeLine - center) / range));
          item.style.setProperty('--reveal-progress', progress.toFixed(3));
        });

        if (this.track && this.icons.length > 1) {
          const listRect = this.track.parentElement.getBoundingClientRect();
          const firstRect = this.icons[0].getBoundingClientRect();
          const lastRect = this.icons[this.icons.length - 1].getBoundingClientRect();
          const trackTop = firstRect.top + (firstRect.height / 2);
          const trackBottom = lastRect.top + (lastRect.height / 2);
          const trackHeight = Math.max(0, trackBottom - trackTop);
          const trackLeft = firstRect.left + (firstRect.width / 2);
          const progress = trackHeight > 0
            ? Math.max(0, Math.min(1, (clearLine - trackTop) / trackHeight))
            : 0;

          this.track.style.top = `${trackTop - listRect.top}px`;
          this.track.style.left = `${trackLeft - listRect.left - (this.track.offsetWidth / 2)}px`;
          this.track.style.height = `${trackHeight}px`;
          this.track.style.setProperty('--track-fill', progress.toFixed(3));
        }
      }
    }

    customElements.define('scroll-reveal-timeline', ScrollRevealTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
